/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiMembershipProduct } from './MembershipProduct';
import { ApiOffer } from './Offer';

export interface RetentionOfferSetRequest {

    /**
     * Retention Offer Set UUID
     */
    uuid?: string;

    /**
     * Name of the retention offer set
     */
    name?: string;

    /**
     * Description of the retention offer set
     */
    description?: string;

    /**
     * Default status of the retention offer set
     */
    default?: boolean;

    /**
     * Available status of the retention offer set
     */
    available?: boolean;

    /**
     * Publish status of the retention offer set
     */
    published?: boolean;

    /**
     * True if the retention offer set contains suggested price options
     */
    is_pay_what_you_want?: boolean;

    /**
     * Minimum amount for monthly PWYW purchase, in cents
     */
    minimum_monthly_price?: number;

    /**
     * Minimum amount for annual PWYW purchase, in cents
     */
    minimum_annual_price?: number;

    /**
     * Number of introductory periods for monthly plans. Applies to Pay What You Want offer sets only. If zero, PWYW is permanent. If non-zero, PWYW is introductory.
     */
    pwyw_monthly_introductory_periods?: number;

    /**
     * Number of introductory periods for annual plans. Applies to Pay What You Want offer sets only. If zero, PWYW is permanent. If non-zero, PWYW is introductory.
     */
    pwyw_annual_introductory_periods?: number;

    /**
     * Kind of the Offer Set
     */
    kind?: string;

    pwyw_monthly_introductory_product?: ApiMembershipProduct;

    pwyw_annual_introductory_product?: ApiMembershipProduct;

    /**
     * Main Rich Text copy to show user as part of the retention offer
     */
    body_text?: string;

    /**
     * Heading to show user, above the body copy
     */
    heading?: string;

    /**
     * Text to show on button/link to the retention offer
     */
    offer_link_text?: string;

    /**
     * URL to the retention offer
     */
    offer_link_url?: string;

    /**
     * Text to show on button to continue with the cancellation
     */
    cancel_link_text?: string;

    image?: string;

    offers?: ApiOffer[];

}

@Model('RetentionOfferSet')
export class ApiRetentionOfferSet extends BaseModel implements RetentionOfferSetRequest {

    /**
     * Retention Offer Set UUID
     */
    
    
    uuid: string;

    /**
     * Name of the retention offer set
     */
    
    
    name: string;

    /**
     * Description of the retention offer set
     */
    
    
    description: string;

    /**
     * Default status of the retention offer set
     */
    
    
    default: boolean;

    /**
     * Available status of the retention offer set
     */
    
    
    available: boolean;

    /**
     * Publish status of the retention offer set
     */
    
    
    published: boolean;

    /**
     * True if the retention offer set contains suggested price options
     */
    
    
    is_pay_what_you_want: boolean;

    /**
     * Minimum amount for monthly PWYW purchase, in cents
     */
    
    
    minimum_monthly_price: number;

    /**
     * Minimum amount for annual PWYW purchase, in cents
     */
    
    
    minimum_annual_price: number;

    /**
     * Number of introductory periods for monthly plans. Applies to Pay What You Want offer sets only. If zero, PWYW is permanent. If non-zero, PWYW is introductory.
     */
    
    
    pwyw_monthly_introductory_periods: number;

    /**
     * Number of introductory periods for annual plans. Applies to Pay What You Want offer sets only. If zero, PWYW is permanent. If non-zero, PWYW is introductory.
     */
    
    
    pwyw_annual_introductory_periods: number;

    /**
     * Kind of the Offer Set
     */
    
    
    kind: string;

    @Type('ApiMembershipProduct')
    @Expand()
    pwyw_monthly_introductory_product: ApiMembershipProduct;

    @Type('ApiMembershipProduct')
    @Expand()
    pwyw_annual_introductory_product: ApiMembershipProduct;

    /**
     * Main Rich Text copy to show user as part of the retention offer
     */
    
    
    body_text: string;

    /**
     * Heading to show user, above the body copy
     */
    
    
    heading: string;

    /**
     * Text to show on button/link to the retention offer
     */
    
    
    offer_link_text: string;

    /**
     * URL to the retention offer
     */
    
    
    offer_link_url: string;

    /**
     * Text to show on button to continue with the cancellation
     */
    
    
    cancel_link_text: string;

    
    
    image: string;

    @Type('ApiOffer')
    @Expand()
    offers: ApiOffer[];

}
